if (!customElements.get('cn-cart-upsell')) {
  class CnCartUpsell extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    async init() {
      // Dynamic/Automatic product recommendation using Shopify recommendation API - start
      
      const newCartResponse = await fetch(`${theme.routes.cart}.js`);
      if (!newCartResponse.ok) throw new Error(newCartResponse.status);
      
      const newCartData = await newCartResponse.json();

      if (!newCartData.items || !newCartData.items.length) return;

      const cart_container = document.querySelector('#cart-drawer .drawer__content');
      const promo_products_container = cart_container.querySelector('.cn_ccu_products_main');
      const promo_products_main = document.querySelector(".cn_atlas_custom_cart_upsell_main");

      if (!promo_products_container || !promo_products_main) return;

      const promo_products_layout = promo_products_main.getAttribute("data-promo_products_layout");
      const promo_products_price_type = promo_products_main.getAttribute("data-promo_products_price");
      const promo_products_quick_add_text = promo_products_main.getAttribute("data-promo_products_quick_add_text");
      const promo_products_quick_add_size = promo_products_main.getAttribute("data-promo_products_quick_add_size");
      const promo_money_with_currency_format = promo_products_main.getAttribute("data-money_with_currency_format");
      const promo_currency_symbol = promo_products_main.getAttribute("data-currency_symbol");
      const promo_product_show_title = promo_products_main.getAttribute("data-promo_product_show_title");
      const promo_excluded_products = promo_products_main.getAttribute("data-excluded_products");
      const promo_product_badge = promo_products_main.getAttribute("data-show_product_badge");
      const promo_sale_badge_txt = promo_products_main.getAttribute("data-sale_badge_txt");
      const promo_exclusive_badge_txt = promo_products_main.getAttribute("data-exclusive_badge_txt");
      const promo_exclusive_badge_padding_x = promo_products_main.getAttribute("data-product_badge_padding_x");
      const promo_exclusive_badge_padding_y = promo_products_main.getAttribute("data-product_badge_padding_y");
      const promo_exclusive_badge_font_size = promo_products_main.getAttribute("data-product_badge_font_size");

      const excludeUnavailableNonRelavantProducts = true;

      const promo_manual_products_list = promo_products_main.querySelector("#cn_ccu_manual_reco_product_list_js");

      const promo_manual_products_list_js = promo_manual_products_list ? JSON.parse(promo_manual_products_list.textContent) : [];

      const excludedProducts = JSON.parse(
        promo_products_main.dataset.excluded_products
      ).map(String);

      const validItem = newCartData.items.find(
        item => !excludedProducts.includes(String(item.product_id))
      );

      const promo_product_parent_id = validItem?.product_id || null;

      let promo_products_length;
      let promo_products_array;

      // Enable below for show pre selected if no recommendations are there - start
      /*
      if(promo_product_parent_id == null){
        promo_products_length = promo_manual_products_list_js.length;
        promo_products_array = promo_manual_products_list_js;
      }else{
        let promo_products_data = await fetch(`/recommendations/products.json?product_id=${promo_product_parent_id}&intent=related`);
        if (!promo_products_data.ok) throw new Error(promo_products_data.status);
        let promo_products = await promo_products_data.json();
        promo_products_length = promo_products.products.length;
        promo_products_array = promo_products.products;
      }
        */
      // Enable above for show pre selected if no recommendations are there - end

      // Disable below for show pre selected if no recommendations are there - start
      if(promo_product_parent_id == null){
        document.getElementById("cn_promo_products_wrapper_id").remove();
        return;
      }
      let promo_products_data = await fetch(`/recommendations/products.json?product_id=${promo_product_parent_id}&intent=related`);
      if (!promo_products_data.ok) throw new Error(promo_products_data.status);
      let promo_products = await promo_products_data.json();
      promo_products_length = promo_products.products.length;
      promo_products_array = promo_products.products;
      // Disable above for show pre selected if no recommendations are there - end


      


      let promo_product_layout_class = "";
      let promo_product_size_option_html_grid = "";
      let promo_product_size_option_html_list = "";

      if (promo_products_layout == "grid") {
        promo_product_layout_class = "slider__item";
      }

      let promo_product_widget_html = [];

      

      /*
      // 👇🏻 working code - written code
      for (var i = 0; i < promo_products_length; i++) {
        let is_relavant_product = true;

        let cn_promo_products = promo_products_array[i];
        let options_html = '';

        if(!excludedProducts.includes(String(cn_promo_products.id))){

          if (cn_promo_products.options && cn_promo_products.options.length > 0) {

            for (let option_index = 0; option_index < cn_promo_products.options.length; option_index++) {

              let option = cn_promo_products.options[option_index];
              let option_name = promo_product_parent_id == null ? cn_promo_products.options[option_index] : option.name;
              let seen_values = [];
              let option_buttons_html = '';

              const variant_lookup = {};

              for (let v = 0; v < cn_promo_products.variants.length; v++) {

                let variant = cn_promo_products.variants[v];
                let current_value = variant.options[option_index];

                if (!variant_lookup[current_value]) {
                  variant_lookup[current_value] = variant;
                }

                if (variant.available && !variant_lookup[current_value].available) {
                  variant_lookup[current_value] = variant;
                }
              }

              if (!this.hasAvailableVariant(variant_lookup, validItem.variant_title)) {
                is_relavant_product = false;
                break;
              }

              for (let value in variant_lookup) {

                let matched_variant = variant_lookup[value];

                seen_values.push(value);

                option_buttons_html += `
                <button
                  type="button"
                  class="cn_ccu_products_size_btn ${!matched_variant.available ? 'is-sold-out' : ''}"
                  data-variant-id="${matched_variant.id}"
                  data-product-id="${cn_promo_products.id}"
                  data-option-index="${option_index}"
                  data-option-value="${value}"
                  ${!matched_variant.available ? 'disabled' : ''}
                >
                  ${value}
                </button>
                `;
              }

              options_html += `
              <div class="cn_ccu_product_size_group" data-option-index="${option_index}">
                <span class="cn_ccu_product_size_label">${option_name}</span>
                <div class="cn_ccu_product_size_buttons">
                  ${option_buttons_html}
                </div>
              </div>
              `;
            }
          }


          if (promo_products_layout == "grid") {

            promo_product_size_option_html_grid = `
            <div class="cn_ccu_products_atc_main">
              <div class="cn_ccu_product_options_main" data-productId="${cn_promo_products.id}">
                ${options_html}
              </div>
              <button class="cn_ccu_products_atc_btn grid" style="padding:${promo_products_quick_add_size}px 0" data-product-id="${cn_promo_products.id}">
                ${promo_products_quick_add_text}
              </button>
            </div>`;

          } else {

            promo_product_size_option_html_list = `
            <div class="cn_ccu_product_options_main" data-productId="${cn_promo_products.id}">
              ${options_html}
            </div>`;
          }

          let promo_product_price_html = "";

          let price_with_currency = promo_money_with_currency_format.replace(
            "{{amount}}",
            (cn_promo_products.price / 100).toFixed(2)
          );

          if (promo_products_price_type == "price_sale_price" && cn_promo_products.compare_at_price != null && cn_promo_products.compare_at_price != 0) {

            promo_product_price_html += `<div class="cn_ccu_product_price">
              <strong class="price__current red--price font-normal"><span class="money">${price_with_currency}</span></strong>
              <s class="price__was"><span class="money">${promo_currency_symbol} ${(cn_promo_products.compare_at_price / 100).toFixed(2)}</span></s>
            </div>`;

          } else {

            promo_product_price_html += `<div class="cn_ccu_product_price">
              <strong class="price__current font-normal"><span class="money">${price_with_currency}</span></strong>
            </div>`;
          }

          let promo_product_title_html = "";
          if(promo_product_show_title == "true"){
            promo_product_title_html += `<a href="/products/${cn_promo_products.handle}" class="cn_ccu_product_title">
              ${cn_promo_products.title}
            </a>`;
          }

          let custom_product_label = "";
          if(promo_product_badge == "true"){
            if(cn_promo_products.tags.indexOf("saltycrushexclusives") != -1 && promo_exclusive_badge_txt != ""){
              custom_product_label = `<span class="cn_custom_product_label product-label product-label--custom">${promo_exclusive_badge_txt}</span>`;
            }else if(cn_promo_products.tags.indexOf("finalsale") != -1 && promo_sale_badge_txt != ""){
              custom_product_label = `<span class="cn_custom_product_label product-label product-label--custom">${promo_sale_badge_txt}</span>`;
            }
          }

          alert("before joining")

          if (is_relavant_product) {
            // continue;
            promo_product_widget_html.push(`
              <div class="cn_ccu_product_wrap ${promo_product_layout_class}" data-product-id="${cn_promo_products.id}">
              <div class="cn_ccu_product_img">
                <a href="/products/${cn_promo_products.handle}" class="cn_ccu_product_title" style="display:block;">
                  ${custom_product_label}
                  <img src="${cn_promo_products.images[0]}" height="150" width="100">
                </a>
                ${promo_product_size_option_html_grid}
              </div>
  
              <div class="cn_ccu_product_details">
                ${promo_product_title_html}
                ${promo_product_price_html}
                ${promo_product_size_option_html_list}
              </div>
  
              <div class="cn_ccu_loading relative is-loading"></div>
            </div>
              `);
          }
        }
      }
      // 👆🏻 working code - written code
      */


      // 👇🏻 code optimized by AI
      for (var i = 0; i < promo_products_length; i++) {
        let is_relavant_product = true;
        let cn_promo_products = promo_products_array[i];
        let options_html = '';

        if (excludedProducts.includes(String(cn_promo_products.id))) continue; // ← early exit for excluded

        if (cn_promo_products.options && cn_promo_products.options.length > 0) {

          for (let option_index = 0; option_index < cn_promo_products.options.length; option_index++) {

            let option = cn_promo_products.options[option_index];
            let option_name = promo_product_parent_id == null ? cn_promo_products.options[option_index] : option.name;
            let option_buttons_html = '';

            const variant_lookup = {};

            for (let v = 0; v < cn_promo_products.variants.length; v++) {
              let variant = cn_promo_products.variants[v];
              let current_value = variant.options[option_index];

              // Keep variant if slot is empty, or if this one is available and current isn't
              if (!variant_lookup[current_value] || (variant.available && !variant_lookup[current_value].available)) {
                variant_lookup[current_value] = variant;
              }
            }

            if (!this.hasAvailableVariant(variant_lookup, validItem.variant_title) && excludeUnavailableNonRelavantProducts) {
              is_relavant_product = false;
              break;
            }

            for (let value in variant_lookup) {
              let matched_variant = variant_lookup[value];

              option_buttons_html += `
              <button
                type="button"
                class="cn_ccu_products_size_btn ${!matched_variant.available ? 'is-sold-out' : ''}"
                data-variant-id="${matched_variant.id}"
                data-product-id="${cn_promo_products.id}"
                data-option-index="${option_index}"
                data-option-value="${value}"
                ${!matched_variant.available ? 'disabled' : ''}
              >
                ${value}
              </button>
              `;
            }

            options_html += `
            <div class="cn_ccu_product_size_group" data-option-index="${option_index}">
              <span class="cn_ccu_product_size_label">${option_name}</span>
              <div class="cn_ccu_product_size_buttons">
                ${option_buttons_html}
              </div>
            </div>
            `;
          }
        }

        // ↓ Skip all HTML generation for irrelevant products — no point building strings we'll discard
        if (!is_relavant_product) continue;

        if (promo_products_layout == "grid") {
          promo_product_size_option_html_grid = `
          <div class="cn_ccu_products_atc_main">
            <div class="cn_ccu_product_options_main" data-productId="${cn_promo_products.id}">
              ${options_html}
            </div>
            <button class="cn_ccu_products_atc_btn grid" style="padding:${promo_products_quick_add_size}px 0" data-product-id="${cn_promo_products.id}">
              ${promo_products_quick_add_text}
            </button>
          </div>`;
        } else {
          promo_product_size_option_html_list = `
          <div class="cn_ccu_product_options_main" data-productId="${cn_promo_products.id}">
            ${options_html}
          </div>`;
        }

        // 👇🏻 country wise currency issue - found and resolved on - 18-06-2026
        // let promo_product_price_html = "";
        // let price_with_currency = promo_money_with_currency_format.replace(
        //   "{{amount}}",
        //   (cn_promo_products.price / 100).toFixed(2)
        // );
        // 👆🏻 country wise currency issue - found and resolved on - 18-06-2026

        var promo_product_price_html = "";

        
        if(promo_money_with_currency_format.indexOf("amount_with_comma_separator") != -1){
          var price_with_currency = promo_money_with_currency_format.replace(
            "{{amount_with_comma_separator}}",
            (cn_promo_products.price / 100).toFixed(2)
          );
        }else if(promo_money_with_currency_format.indexOf("amount_no_decimals") != -1){
          var price_with_currency = promo_money_with_currency_format.replace(
            "{{amount_no_decimals}}",
            (cn_promo_products.price / 100).toFixed(2)
          );
        }else{
          var price_with_currency = promo_money_with_currency_format.replace(
            "{{amount}}",
            (cn_promo_products.price / 100).toFixed(2)
          );
        }


        if (promo_products_price_type == "price_sale_price" && cn_promo_products.compare_at_price != null && cn_promo_products.compare_at_price != 0) {
          promo_product_price_html += `<div class="cn_ccu_product_price">
            <strong class="price__current red--price font-normal"><span class="money">${price_with_currency}</span></strong>
            <s class="price__was"><span class="money">${promo_currency_symbol} ${(cn_promo_products.compare_at_price / 100).toFixed(2)}</span></s>
          </div>`;
        } else {
          promo_product_price_html += `<div class="cn_ccu_product_price">
            <strong class="price__current font-normal"><span class="money">${price_with_currency}</span></strong>
          </div>`;
        }

        let promo_product_title_html = "";
        if (promo_product_show_title == "true") {
          promo_product_title_html += `<a href="/products/${cn_promo_products.handle}" class="cn_ccu_product_title">
            ${cn_promo_products.title}
          </a>`;
        }

        let custom_product_label = "";
        if (promo_product_badge == "true") {
          if (cn_promo_products.tags.indexOf("saltycrushexclusives") != -1 && promo_exclusive_badge_txt != "") {
            custom_product_label = `<span class="cn_custom_product_label product-label product-label--custom">${promo_exclusive_badge_txt}</span>`;
          } else if (cn_promo_products.tags.indexOf("finalsale") != -1 && promo_sale_badge_txt != "") {
            custom_product_label = `<span class="cn_custom_product_label product-label product-label--custom">${promo_sale_badge_txt}</span>`;
          }
        }

        promo_product_widget_html.push(`
          <div class="cn_ccu_product_wrap ${promo_product_layout_class}" data-product-id="${cn_promo_products.id}">
          <div class="cn_ccu_product_img">
            <a href="/products/${cn_promo_products.handle}" class="cn_ccu_product_title" style="display:block;">
              ${custom_product_label}
              <img src="${cn_promo_products.images[0]}" height="150" width="100">
            </a>
            ${promo_product_size_option_html_grid}
          </div>

          <div class="cn_ccu_product_details">
            ${promo_product_title_html}
            ${promo_product_price_html}
            ${promo_product_size_option_html_list}
          </div>

          <div class="cn_ccu_loading relative is-loading"></div>
        </div>
        `);
      }
      // 👆🏻 code optimized by AI

      promo_products_container.innerHTML = promo_product_widget_html.join('');
      
      // cart_container.querySelector('.cn_atlas_custom_cart_upsell_main .cn_ccu_loading_section').remove();

      cart_container.querySelector('.cn_atlas_custom_cart_upsell_main .cn_ccu_loading_section').style.display = "none";

      requestAnimationFrame(() => {
        const slider = cart_container.querySelector('.cn_atlas_custom_cart_upsell_main carousel-slider');

        if (slider && typeof slider.init === 'function') {
          slider.removeAttribute('data-initialized');
          slider.init();
        }
      });

      this.addEventListener('click', this.handleClick.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    /**
     * Handles all click events via event delegation
     */
    handleClick(evt) {
      // Handle size button clicks
      if (evt.target.classList.contains('cn_ccu_products_size_btn')) {
        this.handleSizeClick(evt.target);
      }

      // Handle ATC button clicks
      if (evt.target.classList.contains('cn_ccu_products_atc_btn')) {
        this.handleAtcClick(evt.target);
      }
    }



    hasAvailableVariant(variantLookup, desiredTitle) {
      const variant = variantLookup[desiredTitle];

      return variant && variant.available === true;
    }

    /**
     * Handles size button selection
     */
    handleSizeClick(btn) {
      const sizeGroup = btn.closest('.cn_ccu_product_size_group');
      
      // Deselect all in this group
      sizeGroup
        .querySelectorAll('.cn_ccu_products_size_btn')
        .forEach((b) => b.classList.remove('cn_ccu_product_selected'));
      
      // Select clicked button
      btn.classList.add('cn_ccu_product_selected');
      sizeGroup.dataset.selectedVariantId = btn.dataset.variantId;
      
      this.addToCart(btn.dataset.productId, btn.dataset.variantId);

      // adding event data to google tag and analytics
      gtag('event', 'atlas_cart_upsell_click');

    }

    /**
     * Handles Add to Cart button click
     */
    handleAtcClick(atcBtn) {

      let curr_product_id = atcBtn.getAttribute("data-product-id");
      let curr_product_img = document.querySelector(".cn_ccu_products_main .cn_ccu_product_wrap.slider__item[data-product-id='"+curr_product_id+"'] .cn_ccu_product_img");

      if(!curr_product_img.classList.contains("cn_ccu_active_size")){
        curr_product_img.classList.add("cn_ccu_active_size");
      }else{
        curr_product_img.classList.remove("cn_ccu_active_size");
      }
      document.querySelectorAll('.cn_ccu_products_main .cn_ccu_product_wrap.slider__item .cn_ccu_product_img')
      .forEach((b) => {
        if (b === curr_product_img) return; 
        b.classList.remove('cn_ccu_active_size');
      });
    }

    cnCcuLoading(productId, show) {
        const curr_product = document.querySelector(".cn_ccu_products_main .cn_ccu_product_wrap[data-product-id='"+productId+"']");
        if(show){
            document.querySelectorAll('.cn_ccu_products_main .cn_ccu_product_wrap').forEach((b) => b.classList.remove('cn_ccu_show_loader'));
            curr_product.classList.add('cn_ccu_show_loader');
        }else{
            document.querySelectorAll('.cn_ccu_products_main .cn_ccu_product_wrap').forEach((b) => b.classList.remove('cn_ccu_show_loader'));
        }
    }

    /**
     * Adds product to cart
     */
    async addToCart(productId, variantId) {
        try {
            this.cnCcuLoading(productId, true)

            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', 1);

            let sections = 'cart-icon-bubble';
            sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;

            formData.append('sections_url', window.location.pathname);
            formData.append('sections', sections);

            const fetchRequestOpts = {
            method: 'POST',
            headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
            };

            const response = await fetch('/cart/add.js', fetchRequestOpts);
            if (!response.ok) throw new Error(response.statusText);

            const data = await response.json();


            // CN gift_reward_add_remove
            if(document.querySelector(".atlas_cart_progress_reward_wrapper.cart_rewards_gift") != null){
                
              const newCartResponse = await fetch(`${theme.routes.cart}.js`);
              if (!newCartResponse.ok) throw new Error(newCartResponse.status);
              const newCartData = await newCartResponse.json();

              const cn_new_cart_check_free_gift = newCartData.items.filter(
              (item) => item.variant_id === 61746748096882
              )[0];

              var atlas_reward_gift = document.querySelector(".atlas_cart_progress_reward_wrapper.cart_rewards_gift");

              if(atlas_reward_gift != null){
                var atlas_free_gift_id = atlas_reward_gift.getAttribute("data-freegift");
                var atlas_free_gift_min = atlas_reward_gift.getAttribute("data-threshold");

                var atlasFreeItemInCart = newCartData.items.find(item => item.variant_id === Number(atlas_free_gift_id));

                const all_cart_items = document.querySelector("table.cart-items tr[data-variant-id='"+atlas_free_gift_id+"']");


                if(newCartData.original_total_price >= Number(atlas_free_gift_min) ){
                    if(cn_new_cart_check_free_gift == undefined || typeof cn_new_cart_check_free_gift == "undefined"){
                    await this.addFreeProductToCart(atlas_free_gift_id);
                    }else{
                    // this.removeItemFromCart(atlas_free_gift_id);
                    }
                }else{
                    if(cn_new_cart_check_free_gift != undefined){
                    await this.removeItemFromCart(atlas_free_gift_id);
                    }
                }
              }

              document.dispatchEvent(
                new CustomEvent("dispatch:cart-drawer:refresh", {
                    bubbles: true,
                })
              );
            }else{
              
            }

            // CN gift_reward_add_remove end

            this.updateCartIcon(data);
            const quickAddDrawer = this.closest('quick-add-drawer');
            if (quickAddDrawer) quickAddDrawer.addedToCart();
            setTimeout(() => {
              if (this.cartDrawer) {
                  this.cartDrawer.renderContents(data, !quickAddDrawer && theme.settings.afterAtc === 'drawer');
              } else if (window.location.pathname === theme.routes.cart) {
                const cartItems = document.querySelector('cart-items');
                if (cartItems) {
                  if (cartItems.dataset.empty === 'true') {
                    window.location.reload();
                  } else {
                    cartItems.refresh();
                  }
                }
              }

              setTimeout(function(){
                const shipping_ins_checkbox = document.querySelector("shipping-checkbox input.free_insu_item");
                const total_cart_items = document.querySelectorAll(".cart-items tbody tr").length;
                if(total_cart_items == 1 && !shipping_ins_checkbox.checked){
                  shipping_ins_checkbox.click();
                  shipping_ins_checkbox.checked = true;
                }
              }, 500)

            }, 700);


        }catch (error) {
            console.error('Error adding insurance:', error);
        }finally{
            this.cnCcuLoading(productId, false)
        }
    }

    /**
     * Updates the cart icon count
     */
    updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && response.sections) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    // CN custom function

      /**
     * Adds the free product to the cart.
     */
    async addFreeProductToCart(FREE_PRODUCT_VariantID = parseInt(theme.routes.free_product)) {
      // let FREE_PRODUCT_VariantID = parseInt(theme.routes.free_product);
      const formData = new FormData();
      formData.append("id", FREE_PRODUCT_VariantID);
      formData.append("quantity", 1);

      const fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      };

      try {
        const response = await fetch("/cart/add.js", fetchRequestOpts);
        if (!response.ok) throw new Error(response.statusText);
        const data = await response.json();
        document.dispatchEvent(
          new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true,
          })
        );
      } catch (error) {
        console.error("Error adding Free Product:", error);
      }
      document.dispatchEvent(
        new CustomEvent("dispatch:cart-drawer:refresh", {
          bubbles: true,
        })
      );
    }

  }


  customElements.define('cn-cart-upsell', CnCartUpsell);
}